import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from './card';
import { WsCardProps } from '../../types/ws.types';
import moment from 'moment';
import ImgIconComp from "../../../components/imgcomp";
import WsDeatailsModal from '../../modals/ws-details';
import {updateCard, deleteCard} from '../../actions/card.actions';
import {useDispatch} from 'react-redux';
import ConfirmModal from '../../../styled-base/modal/implementations/confirm-modal';
import { Draggable } from "react-beautiful-dnd";

const WsCard = ({ card, columnId, index, user, userPermission, boardInfo }: WsCardProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const editCard: boolean = (userPermission.editBoard == "1");
    let dates:any = [];
    const targetDate: number = parseInt(card.target_date);
    const startDate: number = parseInt(card.start_date);
    if (!isNaN(startDate) && startDate > 0) {
        dates.push(moment(startDate * 1000).format("MMM DD, YYYY"));
    }
    if (!isNaN(targetDate) && targetDate > 0) {
        dates.push(moment(targetDate * 1000).format("MMM DD, YYYY"));
    }

    const dateText: string = dates.join(' - ');
    const [visibleDeleteIcon, showDeleteIcon] = useState(false);
    const [openWs, setOpenWs] = useState(null);
    const [openDeletePopup, setOpenDeletePopup] = useState(false);

    const onOpenWs = (e?: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        setOpenWs(card);
    }

    const onShowDeleteConfirmModal = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (!editCard) return;
        setOpenDeletePopup(true);
    }

    const saveCallback = (item: any) => {
        console.log('saveCallback');
    }

    const updateWsData = (item: any) => {
        console.log('updateWsData', item);
        dispatch(updateCard(card.board_column, card.id, item));
    }

    const onAcceptDeleteWs = () => {
        console.log('onAcceptDeleteWs');
        if (!editCard) return;
        setOpenDeletePopup(false);
        dispatch(deleteCard(card.board_column, card.id));
    }

    const getItemStyle = (isDragging: boolean, draggableStyle:any) => {
        const {transform, ...rest} = draggableStyle;
        let style = {
            // some basic styles to make the items look a bit nicer
            userSelect: "none",
            // styles we need to apply on draggables
            ...draggableStyle,
        }
        if(isDragging && transform){
            let containerCoordinates = document.querySelector(".mainBoardWrapper").getBoundingClientRect();
            
            let trArray = transform.substring(10, transform.length -1).split(",");
            let transX = draggableStyle.left + parseInt(trArray[0].trim().substring(0, trArray[0].length-2));
            let transY = draggableStyle.top + parseInt(trArray[1].trim().substring(0, trArray[1].length-2));
    
            if(transY < containerCoordinates.top - 10 ){
                if(transX > containerCoordinates.left){
                    style.transform = `translate(${transX - draggableStyle.left}px, -${draggableStyle.top-(containerCoordinates.top - 10)}px)`;
                }else{
                    style.transform = `translate(-${draggableStyle.left-containerCoordinates.left}px, -${draggableStyle.top-(containerCoordinates.top - 10)}px)`;
                }
                
            }else if(transX < containerCoordinates.left){
                style.transform = `translate(-${draggableStyle.left-containerCoordinates.left}px, ${transY - draggableStyle.top}px)`;
            }else{
                style.transform = transform;
            }
        }
        return style;
    };

    return (
        <>
        <Draggable draggableId={`drag-item-${columnId}-${card.id}-${index}`} index={index} >
        {
            (provided:any, snapshot:any) => (
            <div 
                {...provided.draggableProps} 
                {...provided.dragHandleProps} 
                ref={provided.innerRef}
                style={getItemStyle(
                    snapshot.isDragging,
                    provided.draggableProps.style
                  )}
                >
                    <Card 
                        onClick={onOpenWs}
                        onMouseOver={() => {editCard ? showDeleteIcon(true) : false} }
                        onMouseOut={() => { editCard ? showDeleteIcon(false) : false} }>
                        <Card.Body>
                            <div className='ws-card-title-wrapper'>
                                <div className='ws-card-title truncate3'>
                                    {card.name}
                                </div>
                                <div className='ws-card-delete-icon'
                                onClick={(e) => onShowDeleteConfirmModal(e)}
                                    style={{display: (visibleDeleteIcon ? 'block': 'none')}}>
                                    <div >
                                        <ImgIconComp id="delete_image" width="12" height="12" />
                                    </div>
                                </div>
                            </div>
                            <div className='ws-card-subtitle'>
                                    <div className='ws-card-author truncateText'>
                                        {`${card.owner_firstname} ${card.owner_lastname}`}
                                    </div>
                                    <div className='ws-card-date'>
                                        {dateText}
                                    </div>
                                </div>
                        </Card.Body>
                    </Card>
            </div>
            )
        }
        </Draggable>
        {
            openWs ? 
            <WsDeatailsModal 
                item={openWs} 
                onClose={() => setOpenWs(null)} 
                saveCallback={saveCallback}
                boardWsDataUpate={updateWsData}
            />
            : ''
        }
        {
              openDeletePopup ?
              <ConfirmModal
                acceptText={t("Yes")}
                declineText={t("Cancel")}
                title={t("Confirm Deletion")}
                onDecline={() => setOpenDeletePopup(false)}
                onAccept={onAcceptDeleteWs}
              >
                <div>
                {t("Are you sure you want to delete the workstream?")}
                </div>
              </ConfirmModal>
            :''
            }
        </>
    )
}

export default memo(WsCard);
